import { Button } from "@d12labs/ui/button";
import { Link } from "@tanstack/react-router";
import { AuthLayout } from "@/components/pages/auth-layout";

export function NotFoundPage() {
	return (
		<AuthLayout title="Page not found" description="That URL doesn't match any route in this app.">
			<div className="flex flex-col gap-3">
				<p className="text-sm text-muted-foreground">
					If you arrived here from a link inside the app, it's probably stale — the page may have
					moved or been removed.
				</p>
				<Link to="/home">
					<Button className="w-full">Take me home</Button>
				</Link>
			</div>
		</AuthLayout>
	);
}
